import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class StemService {
    static async createStemAsync(projectId, body) {
        return await NetworkService.postAsync(`${API_BASE_URL}/projects/${projectId}/stems`, body);
    }

    static async listStemsAsync(projectId) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${projectId}/stems`);
        return response.items || response || [];
    }

    /**
     * Consent to expose the separated stems in the musician's public library.
     * Off by default: the stems stay private to the project until it is given.
     * @param {string}  stemId
     * @param {boolean} consent
     */
    static async setStemConsentAsync(stemId, consent) {
        return await NetworkService.patchAsync(`${API_BASE_URL}/stems/${stemId}/consent`, {
            stem_consent: Boolean(consent),
        });
    }
}
